export default {
  sidePanelSubtitle: "The second batch is ready to be shipped out.",
  sidePanelTitle: "Hurray!",
  subtitle: "Output volume for second batch",
  tag: "Middle of the day",
  title: "Production overview",
  ctaText: "Let's distribute"
};
